import React, { useRef, useEffect } from 'react';

import { connect } from 'react-redux';

import styled from 'styled-components';

import { SEO } from '../components/SEO';

import { setHeroVisible } from '../state/actions';

import HomePageHeroOwnTomorrowContainer from '../containers/HomePageHeroOwnTomorrowContainer';
import PioneerGalleryContainer from '../containers/PioneerGalleryContainer';
import CoinbasePartnershipContainer from '../containers/CoinbasePartnershipContainer';
import DeedsOnchainContainer from '../containers/DeedsOnchainContainer';
import ResearchBackedContainer from '../containers/ResearchBackedContainer';
import UniversityEndlessScrollContainer from '../containers/UniversityEndlessScrollContainer';
import TeamGalleryContainer from '../containers/TeamGalleryContainer';
import TestimonialsEndlessScrollContainer from '../containers/TestimonialsEndlessScrollContainer';
import InvestorsContainer from '../containers/InvestorsContainer';
import FooterContainer from '../containers/FooterContainer';
import NavBarContainer from '../containers/NavBarContainer';
import FeaturedListingsContainer from '../containers/FeaturedListingsContainer';
import EarnProContainer from '../containers/EarnProContainer';

const Segment = styled.div`
  padding-top: ${props => props.mobile ? props.theme.spacing(6) : props.theme.spacing(12)};
  padding-bottom: ${props => props.mobile ? props.theme.spacing(6) : props.theme.spacing(12)};
`

const IndexPage = ({
  isConsideredMobile,
  setHeroVisible,
  isHeroVisible,
}) => {
  const heroRef = useRef(null);

  useEffect(() => {
    const currentHeroRef = heroRef.current;

    const checkInitialVisibility = () => {
      if (currentHeroRef) {
        const rect = currentHeroRef.getBoundingClientRect();
        const isInitiallyVisible = rect.top < window.innerHeight && rect.bottom > 0;
        setHeroVisible(isInitiallyVisible);
      }
    };

    const timeoutId = setTimeout(checkInitialVisibility, 100);

    const observer = new IntersectionObserver(
      ([entry]) => {
        setHeroVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    if (currentHeroRef) {
      observer.observe(currentHeroRef);
    }

    const handleScroll = () => {
      if (currentHeroRef) {
        const rect = currentHeroRef.getBoundingClientRect();
        setHeroVisible(rect.top < window.innerHeight && rect.bottom > 0);
      }
    };

    window.addEventListener('scroll', handleScroll);

    const cleanupTimeoutId = setTimeout(() => {
      window.removeEventListener('scroll', handleScroll);
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(cleanupTimeoutId);
      window.removeEventListener('scroll', handleScroll);
      if (currentHeroRef) {
        observer.unobserve(currentHeroRef);
      }
    };
  }, [setHeroVisible]);

  return (
    <div style={{paddingTop: isConsideredMobile ? '0px' : '0px'}}>
      <NavBarContainer forceOpacity={true} />
      <div ref={heroRef}>
        <HomePageHeroOwnTomorrowContainer />
      </div>
      <Segment mobile={isConsideredMobile} id="earn-pro">
        <EarnProContainer />
      </Segment>
      <Segment mobile={isConsideredMobile}>
        <PioneerGalleryContainer />
      </Segment>
      <Segment mobile={isConsideredMobile}>
        <CoinbasePartnershipContainer />
      </Segment>
      <Segment mobile={isConsideredMobile}>
        <DeedsOnchainContainer />
      </Segment>
      <Segment mobile={isConsideredMobile}>
        <FeaturedListingsContainer />
      </Segment>
      <Segment mobile={isConsideredMobile}>
        <ResearchBackedContainer />
      </Segment>
      <Segment mobile={isConsideredMobile}>
        <UniversityEndlessScrollContainer />
      </Segment>
      <Segment mobile={isConsideredMobile}>
        <TeamGalleryContainer />
      </Segment>
      <Segment mobile={isConsideredMobile} style={{backgroundColor: '#F9F9F9'}}>
        <TestimonialsEndlessScrollContainer/>
      </Segment>
      <Segment mobile={isConsideredMobile}>
        <InvestorsContainer />
      </Segment>
      <Segment mobile={isConsideredMobile} style={{backgroundColor: '#F2F8FF'}}>
        <FooterContainer />
      </Segment>
    </div>
  );
}

export const Head = () => (
  <SEO />
)

const mapStateToProps = (state) => ({
  isConsideredMobile: state.isConsideredMobile,
  isHeroVisible: state.isHeroVisible,
});

export default connect(mapStateToProps, { setHeroVisible })(IndexPage);